export const BLOCK1_QUESTIONS = [
  'q1',
  'q2',
  'q3',
  'q4',
  'q5',
  'q6',
  'q7',
  'q8',
  'q9',
  'q10',
  'q11',
  'q12',
] as const;

export const BLOCK2_QUESTIONS = [
  'q13',
  'q14',
  'q15',
  'q16',
  'q17',
  'q18',
] as const;

export const BLOCK3_QUESTIONS = ['q19', 'q20', 'q21', 'q22'] as const;

export type ScoredQuestionKey =
  | (typeof BLOCK1_QUESTIONS)[number]
  | (typeof BLOCK2_QUESTIONS)[number]
  | (typeof BLOCK3_QUESTIONS)[number];

export const Q13_OTHER_QUESTION = 'q13';

export const Q13_OTHER_ORDER = 4;

export const Q23_OTHER_ORIGIN_ORDER = 8;

export interface ConsilioWealthOrigin {
  estimatedTotalWealth?: number;
  origins?: number[];
  otherOrigin?: string;
}

export const S1_SELF_DETERMINED_ORDER = 3;

export const S3_TAXONOMY_ORDER = 1;

export const S3_SFDR_ORDER = 2;

export const S3_ADVERSE_IMPACT_ORDER = 3;

export const S2_MIN_PERCENTAGE = 0;

export const S2_MAX_PERCENTAGE = 100;

export interface ConsilioSustainabilityAnswers {
  s1?: number;
  s2?: number;
  s3?: number[];
  s4?: number;
  s5?: number;
  s6?: number[];
}

export type ConsilioAnswers = Partial<Record<ScoredQuestionKey, number>> & {
  q13Other?: string;
  q23?: ConsilioWealthOrigin;
  q24?: number;
  sustainability?: ConsilioSustainabilityAnswers;
};
